/**
 * Global control bar component
 */

import type { Scenario } from '../types/scenario';
import { SCENARIOS, getScenarioByKey } from '../scenarios/builtin';

export interface ControlsEvents {
  onPlayAll?: () => void;
  onPauseAll?: () => void;
  onPlayActive?: () => void;
  onPauseActive?: () => void;
  onLoadScenario?: (scenario: Scenario) => void;
}

export class Controls {
  private playAllBtn: HTMLButtonElement;
  private pauseAllBtn: HTMLButtonElement;
  private playActiveBtn: HTMLButtonElement;
  private pauseActiveBtn: HTMLButtonElement;
  private scenarioSelect: HTMLSelectElement;
  private loadBtn: HTMLButtonElement;
  private activeCellInfo: HTMLSpanElement;
  private globalFps: HTMLSpanElement;

  private events: ControlsEvents;

  constructor(events: ControlsEvents = {}) {
    this.events = events;

    // Get DOM elements
    this.playAllBtn = document.getElementById('btn-play-all') as HTMLButtonElement;
    this.pauseAllBtn = document.getElementById('btn-pause-all') as HTMLButtonElement;
    this.playActiveBtn = document.getElementById('btn-play-active') as HTMLButtonElement;
    this.pauseActiveBtn = document.getElementById('btn-pause-active') as HTMLButtonElement;
    this.scenarioSelect = document.getElementById('scenario-select') as HTMLSelectElement;
    this.loadBtn = document.getElementById('btn-load-active') as HTMLButtonElement;
    this.activeCellInfo = document.getElementById('active-cell-info') as HTMLSpanElement;
    this.globalFps = document.getElementById('global-fps') as HTMLSpanElement;

    this.setupEventListeners();
  }

  /**
   * Update active cell display
   */
  setActiveCell(cellId: string | null): void {
    if (cellId) {
      // Parse cell-row-col format
      const match = cellId.match(/^cell-(\d+)-(\d+)$/);
      if (match) {
        const row = parseInt(match[1], 10) + 1;
        const col = parseInt(match[2], 10) + 1;
        this.activeCellInfo.textContent = `Active: ${row}-${col}`;
      } else {
        this.activeCellInfo.textContent = `Active: ${cellId}`;
      }
    } else {
      this.activeCellInfo.textContent = 'Active: none';
    }
  }

  /**
   * Update global FPS display
   */
  setGlobalFps(fps: number): void {
    this.globalFps.textContent = `FPS: ${fps}`;
  }

  private setupEventListeners(): void {
    this.playAllBtn.addEventListener('click', () => {
      this.events.onPlayAll?.();
    });

    this.pauseAllBtn.addEventListener('click', () => {
      this.events.onPauseAll?.();
    });

    this.playActiveBtn.addEventListener('click', () => {
      this.events.onPlayActive?.();
    });

    this.pauseActiveBtn.addEventListener('click', () => {
      this.events.onPauseActive?.();
    });

    this.loadBtn.addEventListener('click', () => {
      const key = this.scenarioSelect.value;
      if (key) {
        const scenario = getScenarioByKey(key);
        if (scenario) {
          this.events.onLoadScenario?.(scenario);
        }
      }
    });
  }
}
